"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.socialMedia.column.platform': 'Platforma',
    'settings.socialMedia.column.status': 'Status',
    'settings.socialMedia.x.title': 'X (Twitter)',
    'settings.socialMedia.x.description': 'Połącz konto X, aby publikować posty.',
    'settings.socialMedia.x.connect': 'Połącz X',
    'settings.socialMedia.x.disconnect': 'Odłącz X',
    'settings.socialMedia.x.disconnected': 'X odłączono',
    'settings.socialMedia.x.connectFailed': 'Nie udało się połączyć X',
    'settings.socialMedia.x.disconnectFailed': 'Nie udało się odłączyć X',
    'settings.socialMedia.ig.title': 'Instagram',
    'settings.socialMedia.ig.description': 'Połącz konto Instagram Business, aby publikować posty.',
    'settings.socialMedia.ig.connect': 'Połącz Instagram',
    'settings.socialMedia.ig.disconnect': 'Odłącz Instagram',
    'settings.socialMedia.ig.disconnected': 'Instagram odłączony',
    'settings.socialMedia.ig.connectFailed': 'Nie udało się połączyć z Instagram',
    'settings.socialMedia.ig.disconnectFailed': 'Nie udało się odłączyć Instagram',
    'settings.socialMedia.fb.title': 'Facebook',
    'settings.socialMedia.fb.description': 'Połącz konto Facebook, aby publikować posty.',
    'settings.socialMedia.fb.connect': 'Połącz Facebook',
    'settings.socialMedia.fb.disconnect': 'Odłącz Facebook',
    'settings.socialMedia.fb.disconnected': 'Facebook odłączono',
    'settings.socialMedia.fb.connectFailed': 'Nie udało się połączyć Facebook',
    'settings.socialMedia.fb.disconnectFailed': 'Nie udało się odłączyć Facebook',
    'settings.socialMedia.yt.title': 'YouTube',
    'settings.socialMedia.yt.description': 'Połącz kanał YouTube, aby publikować filmy.',
    'settings.socialMedia.yt.connect': 'Połącz YouTube',
    'settings.socialMedia.yt.disconnect': 'Odłącz YouTube',
    'settings.socialMedia.yt.disconnected': 'YouTube odłączony',
    'settings.socialMedia.yt.connectFailed': 'Nie udało się połączyć z YouTube',
    'settings.socialMedia.yt.disconnectFailed': 'Nie udało się odłączyć YouTube',
    'settings.socialMedia.tt.title': 'TikTok',
    'settings.socialMedia.tt.description': 'Połącz konto TikTok, aby publikować filmy.',
    'settings.socialMedia.tt.connect': 'Połącz TikTok',
    'settings.socialMedia.tt.disconnect': 'Odłącz TikTok',
    'settings.socialMedia.tt.disconnected': 'TikTok odłączony',
    'settings.socialMedia.tt.connectFailed': 'Nie udało się połączyć z TikTok',
    'settings.socialMedia.tt.disconnectFailed': 'Nie udało się odłączyć TikTok',
    'settings.socialMedia.li.title': 'LinkedIn',
    'settings.socialMedia.li.description': 'Połącz konto LinkedIn, aby publikować posty.',
    'settings.socialMedia.li.connect': 'Połącz LinkedIn',
    'settings.socialMedia.li.disconnect': 'Odłącz LinkedIn',
    'settings.socialMedia.li.disconnected': 'LinkedIn odłączony',
    'settings.socialMedia.li.connectFailed': 'Nie udało się połączyć z LinkedIn',
    'settings.socialMedia.li.disconnectFailed': 'Nie udało się odłączyć LinkedIn',
    'settings.socialMedia.pt.title': 'Pinterest',
    'settings.socialMedia.pt.description': 'Połącz konto Pinterest, aby publikować Piny.',
    'settings.socialMedia.pt.connect': 'Połącz Pinterest',
    'settings.socialMedia.pt.disconnect': 'Odłącz Pinterest',
    'settings.socialMedia.pt.disconnected': 'Pinterest odłączony',
    'settings.socialMedia.pt.connectFailed': 'Nie udało się połączyć z Pinterest',
    'settings.socialMedia.pt.disconnectFailed': 'Nie udało się odłączyć Pinterest',
    'settings.socialMedia.th.title': 'Threads',
    'settings.socialMedia.th.description': 'Połącz konto Threads, aby publikować treści.',
    'settings.socialMedia.th.connect': 'Połącz Threads',
    'settings.socialMedia.th.disconnect': 'Odłącz Threads',
    'settings.socialMedia.th.disconnected': 'Threads odłączony',
    'settings.socialMedia.th.connectFailed': 'Nie udało się połączyć z Threads',
    'settings.socialMedia.th.disconnectFailed': 'Nie udało się odłączyć Threads',
    'settings.socialMedia.dictionary.title': 'Słowniki Social Media',
    'settings.socialMedia.dictionary.type': 'Typ',
    'settings.socialMedia.dictionary.type.tone': 'Ton',
    'settings.socialMedia.dictionary.type.goal': 'Cel',
    'settings.socialMedia.dictionary.key': 'Klucz',
    'settings.socialMedia.dictionary.label': 'Etykieta',
    'settings.socialMedia.dictionary.icon': 'Ikona',
    'settings.socialMedia.dictionary.order': 'Kolejność',
    'settings.socialMedia.dictionary.active': 'Aktywny',
    'settings.socialMedia.dictionary.add': 'Dodaj',
    'settings.socialMedia.dictionary.edit': 'Edytuj',
    'settings.socialMedia.dictionary.delete': 'Usuń',
    'settings.socialMedia.dictionary.editTitle': 'Edytuj element słownika',
    'settings.socialMedia.dictionary.addTitle': 'Dodaj element słownika',
    'settings.socialMedia.dictionary.save': 'Zapisz',
    'settings.socialMedia.dictionary.cancel': 'Anuluj',
    'settings.socialMedia.dictionary.loadFailed': 'Nie udało się załadować słowników',
    'settings.socialMedia.dictionary.fillRequired': 'Wypełnij wszystkie wymagane pola',
    'settings.socialMedia.dictionary.saved': 'Element słownika zapisany',
    'settings.socialMedia.dictionary.saveFailed': 'Nie udało się zapisać elementu słownika',
    'settings.socialMedia.dictionary.deleted': 'Element słownika usunięty',
    'settings.socialMedia.dictionary.deleteFailed': 'Nie udało się usunąć elementu słownika',
    'settings.socialMedia.dictionary.deleteConfirm': 'Czy na pewno chcesz usunąć ten element słownika?',
};
